var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

/* ===============================
   GA4 Helper Function
================================ */
function trackGA4(eventName, params = {}) {
  if (typeof gtag === "function") {

    console.log("gtag available?", typeof gtag);

    gtag("event", eventName, {
      debug_mode: true,   // ✅ DebugView ma event show karse
      ...params
    });

  } else {
    console.warn("gtag not available");
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initButtons();
  initGrid();
});

/* ===============================
   Wishlist Updated Event
================================ */
document.addEventListener('shopify-wishlist:updated', function (event) {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);

  trackGA4("view_item_list", {
    item_list_name: "Wishlist",
    items: wishlist.map(handle => ({
      item_id: handle
    }))
  });
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

/* ===============================
   Grid Setup
================================ */
var setupGrid = function (grid) {
  var wishlist = getWishlist();

  if (wishlist.length === 0) {
    document.querySelector('#wishlist').innerHTML = '<p class="wishlist-empty-message">You have 0 items in your selection.</p>';
    document.querySelector('.template-wishlist #shopify-section-product-list').classList.add("active");
    grid.classList.add(GRID_LOADED_CLASS);
    return;
  } else {
    document.querySelector('#wishlist').classList.add("active");
  }

  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });

  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  });
};

/* ===============================
   Button Setup
================================ */
var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    var productTitle = button.dataset.productTitle || 'Product';
    var productPrice = button.dataset.productPrice || 0;

    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle`.');

    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }

    button.addEventListener('click', function () {
      const isAlreadyInWishlist = wishlistContains(productHandle);

      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);

      /* ---------- GA4 Tracking ---------- */

      if (!isAlreadyInWishlist) {
        // ADD to wishlist
        trackGA4("add_to_wishlist", {
          currency: Shopify.currency.active,
          value: productPrice / 100,
          items: [
            {
              item_id: productHandle,
              item_name: productTitle,
              price: productPrice / 100
            }
          ]
        });

        showWishlistPopup(productTitle, `/products/${productHandle}`);

        // Track popup open
        trackGA4("open_wishlist_popup");

      } else {
        // REMOVE from wishlist
        trackGA4("wishlist_remove", {
          currency: Shopify.currency.active,
          value: productPrice / 100,
          items: [
            {
              item_id: productHandle,
              item_name: productTitle,
              price: productPrice / 100,
              quantity: 1
            }
          ]
        });
      }
    });
  });
};

/* ===============================
   Init Functions
================================ */
var initGrid = function () {
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;

  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

/* ===============================
   LocalStorage Functions
================================ */
var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

/* ===============================
   Popup Function
================================ */
function showWishlistPopup(title, url) {
  const popup = document.getElementById('wishlist-popup');
  if (!popup) return;

  popup.querySelector('.wishlist-popup-title').textContent = title;
  popup.classList.add('show');

  setTimeout(() => {
    popup.classList.remove('show');
  }, 4000);
}
